<template>
  <div class="profile-layout">
    <h1 class="profile-layout__title q-my-none">{{ title }}</h1>

    <div class="profile-layout__content">
      <div class="profile-layout__sidebar">
        <slot name="sidebar"></slot>
      </div>

      <div class="profile-layout__main">
        <slot name="main"></slot>
      </div>
    </div>

    <div class="profile-layout__footer">
      <BaseButton class="profile-layout__back-btn" :icon_style="{ height: '12px', width: '8px' }" icon="arrow-left" :label="$t('BACK')" @click.native="$router.push({ name: 'home' })" />
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
// Base components
import BaseButton from '@base/BaseButton.vue';

/**
 * Layout component for profile pages
 * Provides a consistent structure with title, sidebar and main content area
 */
export default {
  name: 'ProfileLayout',
  components: {
    BaseButton
  },
  props: {
    /**
     * Page title displayed at the top
     */
    title: {
      type: String,
      default: 'Account Settings'
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 24px 16px 24px;
  position: relative;
  text-align: left;

  &__title {
    @include mona-sans-font($size: 32px, $bolded: true, $color: var(--main-text-color));
    margin-bottom: 16px;
  }

  &__content {
    display: flex;
    flex: 1;
    gap: 64px;
    min-height: 0;
  }

  &__sidebar {
    flex-shrink: 0;
    width: 100%;
    max-width: 280px;
  }

  &__main {
    flex: 1;
    max-height: 100vh;
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    padding-top: 16px;
  }
}

@include responsive($max: md) {
  .profile-layout {
    padding: 16px 24px;
    height: auto;
    margin-top: 130px;

    &__content {
      flex-direction: column;
    }

    &__sidebar {
      width: 100%;
      max-width: 100%;
      margin-bottom: 16px;
    }

    &__main {
      max-height: none;
    }
  }
}
</style>
